import { useEffect, useRef, useState } from 'react';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import { FocusTrap } from 'focus-trap-react';
import { injectIntl } from 'react-intl';
import { Portal } from 'react-portal';
import { useDispatch, useSelector } from 'react-redux';

import { closeManageCookies } from '../../actions';
import { buttons, groups, ModalFooter, ModalHeader } from '../../messages';
import withLgpdCookie from '../withLgpdCookie';

import { Group } from './components';
import styles from './ManageCookies.module.less';

const ManageCookies = ({
  intl,
  performanceCookies,
  thirdPartyCookies,
  rejectCookies,
  saveCookies,
  removePerformanceCookies,
  isClient,
  // has_accepted=false,
  // onClose,
  // onSave,
  //  onReject
}) => {
  const initialFocusRef = useRef(null);
  const dispatch = useDispatch();
  const { modalOpen } = useSelector((state) => state.manageCookies);

  const [performance, setPerformance] = useState(performanceCookies);
  const [thirdParty, setThirdParty] = useState(thirdPartyCookies);

  useEffect(() => {
    setPerformance(performanceCookies);
    setThirdParty(thirdPartyCookies);
  }, [performanceCookies, thirdPartyCookies]);

  const handleClose = () => {
    dispatch(closeManageCookies());
  };

  const handleSave = () => {
    saveCookies({ performance, thirdParty });
    handleClose();
  };

  const handleReject = () => {
    rejectCookies();
    handleClose();
  };

  useEffect(() => {
    if (!performanceCookies) {
      removePerformanceCookies();
    }
  }, [performanceCookies, removePerformanceCookies]);

  if (!modalOpen || !isClient) {
    return null;
  }

  return (
    <>
      <BodyClass className={styles.noScroll} />
      <Portal>
        <div className={styles.overlay} />
        <FocusTrap
          focusTrapOptions={{
            escapeDeactivates: true, // ⎋ ESC fecha
            onDeactivate: () => {
              handleClose();
            },
            allowOutsideClick: true, // permite clique fora
            clickOutsideDeactivates: false,
            returnFocusOnDeactivate: true,
            initialFocus: () => initialFocusRef.current,
            preventScroll: true,
          }}
        >
          <div className={styles.modal}>
            <button
              ref={initialFocusRef}
              className={`br-button circle small ${styles.btnFechar}`}
              title={intl.formatMessage(buttons.closeWithoutSave)}
              onClick={handleClose}
            >
              <i className="fas fa-times" aria-hidden="true" />
            </button>

            <div className={styles.header}>
              <ModalHeader />
            </div>

            <div className={styles.content}>
              <Group
                readonly
                checked={true}
                title={intl.formatMessage(groups.strictlyNecessary.title)}
              >
                <groups.strictlyNecessary.description />
              </Group>

              <Group
                checked={performance}
                handleChange={(value) => setPerformance(value)}
                title={intl.formatMessage(groups.performance.title)}
              >
                <groups.performance.description />
              </Group>

              <Group
                checked={thirdParty}
                handleChange={(value) => setThirdParty(value)}
                title={intl.formatMessage(groups.thirdParty.title)}
              >
                <groups.thirdParty.description />
              </Group>

              <ModalFooter />
            </div>

            <div className={`br-divider ${styles.divider}`} />

            <div className={styles.footer}>
              <button
                className="br-button small secondary"
                onClick={handleReject}
              >
                {intl.formatMessage(buttons.rejectCookies)}
              </button>
              <button
                className="br-button small secondary"
                onClick={handleSave}
              >
                {intl.formatMessage(buttons.save)}
              </button>
            </div>
          </div>
        </FocusTrap>
      </Portal>
    </>
  );
};

export default withLgpdCookie(injectIntl(ManageCookies));
